import { useAppStore } from '@store'
import is2DMode from '@utils/is2DMode'

type Props = { position: [number, number, number] }
export default function VerticalLine({ position }: Props) {
  const VERTICAL_WALL_ARGS = [8, 100] satisfies [
    width?: number | undefined,
    height?: number | undefined,
    depth?: number | undefined,
    widthSegments?: number | undefined,
    heightSegments?: number | undefined,
    depthSegments?: number | undefined,
  ]
  const EXTRA_DIMENTIONS_DISTANCE = useAppStore.use.prefs()?.DISTCOTAPARED ?? 0
  const PREFS_COLOR_COTA = useAppStore((store) => store.prefs?.['C/LINEASCOTA'])
  const PREFS_COLOR_COTA3 = useAppStore((store) => store.prefs?.['C/LINEASCOTA3D'])
  const mode = is2DMode(useAppStore((store) => store.mode))
  const colorLinea = mode ? PREFS_COLOR_COTA : PREFS_COLOR_COTA3

  {
    /* This will be a vertical line */
  }
  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={position}
    >
      <boxGeometry args={VERTICAL_WALL_ARGS} />
      <meshBasicMaterial color={colorLinea} />
    </mesh>
  )
}
